define([
	"dojo/_base/array",
	"dojo/_base/declare",
	"csi/table/AggregateFrom",
	"csi/view"
], function(array, declare, AggregateFrom, view) {

	return declare(AggregateFrom, {
		postProcessSuccess: function() {
			// summary: refresh row if common value, otherwise refresh cell
			array.forEach(view.getAllViews("Orders"), function(v) {
				var p = v.getPlugin("SelectPOProduct");
				if (p) {
					p.refreshStore();
				}
			});

			return this.inherited(arguments);
		}
	});
});